import React from "react";
import { PortableCoverSheet } from "./CoverLetterPortable";
import { ResumePageOne, ResumePageTwo } from "./Resume";

/**
 * Portable application pack — generic cover letter + resume, no company name.
 * Single PDF download via /api/application-portable/pdf.
 */

const SANS = "Inter, -apple-system, BlinkMacSystemFont, sans-serif";

const ApplicationPortable = () => (
    <main
        data-testid="application-portable-page"
        style={{
            backgroundColor: "#2a2620",
            minHeight: "100vh",
            padding: "40px 16px 80px",
            fontFamily: SANS,
        }}
    >
        <div
            className="application-toolbar"
            style={{
                maxWidth: 794,
                margin: "0 auto 24px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 12,
                flexWrap: "wrap",
            }}
        >
            <div>
                <p
                    style={{
                        color: "#c9a227",
                        fontSize: 11,
                        letterSpacing: "0.3em",
                        textTransform: "uppercase",
                        margin: 0,
                        fontWeight: 600,
                    }}
                >
                    Tatva K · Application Pack (Portable) · 3 pages
                </p>
                <p
                    style={{
                        color: "#9a8c70",
                        fontSize: 10,
                        margin: "4px 0 0",
                        letterSpacing: "0.04em",
                    }}
                >
                    Generic — no company name. Cover Letter → Resume (p1) → Resume (p2)
                </p>
            </div>
            <a
                href={`${process.env.REACT_APP_BACKEND_URL}/api/application-portable/pdf`}
                download="Tatva-K-Application-Pack-Portable.pdf"
                data-testid="application-portable-download-btn"
                style={{
                    backgroundColor: "#c9a227",
                    color: "#1a1a1a",
                    border: "none",
                    padding: "12px 26px",
                    fontSize: 11,
                    letterSpacing: "0.22em",
                    textTransform: "uppercase",
                    fontWeight: 700,
                    cursor: "pointer",
                    borderRadius: 999,
                    textDecoration: "none",
                    display: "inline-block",
                }}
            >
                Download PDF
            </a>
        </div>

        <PortableCoverSheet />
        <ResumePageOne portable />
        <ResumePageTwo />
    </main>
);

export default ApplicationPortable;
